import './DownloadLimit.css'
import * as React from "react";
import {Link} from "react-router-dom";
import {isDonator, isLoggedIn} from "../../Functions/Authentication";
import {getMyLimit} from "../../Functions/DownloadLimits";
import {getCurrentPageURL} from "../../Functions/CurrentPage";

class DownloadLimit extends React.Component {
  render() {
    return (
        <div className="download-limits-text blue-link" style={this.props.style}>
          You can {this.props.action} {getMyLimit()} {this.props.mediaType} per day.
          {
            isLoggedIn()
                ? (isDonator() ? <span> Thank you for being a <Link to="/donation">donator</Link>.</span> : <span> Want to increase your daily limit? Please consider making a <Link to="/donation">donation</Link>.</span>)
                : <span className="blue-link"> Want to increase your daily your limit? <Link to={{pathname: "/login", state: {redirectTo: getCurrentPageURL()}}}>Login</Link>, or <Link to="/register">register</Link> for a free account.</span>
          }
          <br/> <br/>
          Having issues downloading? Please read our <Link to="/faq">FAQs</Link>.
        </div>
    );
  }
}

export default DownloadLimit;
